function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M7 13A6 6 0 107 1a6 6 0 000 12z",
  stroke: "#555",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 7h12",
  stroke: "#555",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M7 1a9.18 9.18 0 012.4 6A9.18 9.18 0 017 13a9.18 9.18 0 01-2.4-6A9.18 9.18 0 017 1v0z",
  stroke: "#555",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgGlobeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgGlobeinline;